import { render, staticRenderFns } from "./maintenance-test-process-info.vue?vue&type=template&id=81f12852&scoped=true&"
import script from "./maintenance-test-process-info.vue?vue&type=script&lang=js&"
export * from "./maintenance-test-process-info.vue?vue&type=script&lang=js&"
import style0 from "./maintenance-test-process-info.vue?vue&type=style&index=0&id=81f12852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f12852",
  null
  
)

export default component.exports